import React from "react";
import { useState, useEffect } from "react";

const inp = "w-full border border-gray-200 rounded-lg px-3 py-2 text-sm";
const lbl = "block text-xs font-semibold text-gray-600 mb-1";

// Apibrėžta už komponento ribų — jei būtų viduje, React laikytų ją nauju
// komponento tipu kiekviename render'e ir perkurtų <input> DOM elementą po
// kiekvieno klavišo paspaudimo (dėl to fokusas dingdavo įvedus vieną raidę).
function F({ label, field, editing, form, setForm, type, placeholder }) {
  return (
    <div className="mb-3">
      <label className={lbl}>{label}</label>
      {editing
        ? <input type={type||'text'} className={inp} value={form[field]||''} onChange={e=>setForm(p=>({...p,[field]:e.target.value}))} placeholder={placeholder||''}/>
        : <div className="px-3 py-2 text-sm border border-transparent rounded-lg bg-gray-50 text-gray-800">{form[field]||<span className="text-gray-300">—</span>}</div>
      }
    </div>
  );
}

export function ProfilisView({ profilis, setProfilis }) {
          const [editing, setEditing] = useState(false);
          const [form, setForm] = useState(profilis);

          useEffect(() => { setForm(profilis); }, [profilis]);

          const fp = { editing, form, setForm };

          return (
            <div className="max-w-2xl mx-auto p-6">
              <div className="bg-white rounded-xl shadow p-6">
                <div className="flex items-center justify-between mb-6">
                  <div>
                    <h2 className="text-xl font-bold text-gray-800">👤 Mano profilis</h2>
                    <p className="text-sm text-gray-500 mt-1">Jūsų rekvizitai naudojami sąmatoms ir pasiūlymams sudaryti</p>
                  </div>
                  {!editing
                    ? <button onClick={()=>setEditing(true)} className="px-4 py-2 rounded-lg bg-ral3000 text-white text-sm font-semibold">✏️ Redaguoti</button>
                    : <div className="flex gap-2">
                        <button onClick={()=>{setProfilis(form);setEditing(false);}} className="px-4 py-2 rounded-lg bg-ral7012 text-white text-sm font-semibold">💾 Išsaugoti</button>
                        <button onClick={()=>{setForm(profilis);setEditing(false);}} className="px-4 py-2 rounded-lg bg-stone-100 text-gray-600 text-sm font-semibold">Atšaukti</button>
                      </div>
                  }
                </div>

                {/* Asmens tipas */}
                <div className="mb-4">
                  <label className={lbl}>Veiklos tipas</label>
                  {editing ? (
                    <div className="flex gap-0 bg-stone-100 rounded-lg overflow-hidden border border-gray-200 w-fit">
                      <button onClick={()=>setForm(p=>({...p,type:'individual'}))} className={"px-4 py-2 text-sm font-semibold transition-all "+(form.type==='individual'?'bg-ral7012 text-white':'text-gray-500')}>Individuali veikla</button>
                      <button onClick={()=>setForm(p=>({...p,type:'company'}))} className={"px-4 py-2 text-sm font-semibold transition-all "+(form.type==='company'?'bg-ral7012 text-white':'text-gray-500')}>Juridinis asmuo (UAB/MB)</button>
                    </div>
                  ) : (
                    <div className="px-3 py-2 text-sm bg-gray-50 rounded-lg text-gray-800">
                      {form.type==='company'?'Juridinis asmuo (UAB/MB)':'Individuali veikla'}
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-2 gap-4">
                  {form.type === 'company' ? (
                    <>
                      <F {...fp} label="Įmonės pavadinimas" field="companyName" placeholder="UAB Pavyzdys"/>
                      <F {...fp} label="Įmonės kodas" field="companyCode" placeholder="123456789"/>
                      <F {...fp} label="PVM mokėtojo kodas" field="pvmCode" placeholder="LT123456789"/>
                      <F {...fp} label="Direktorius / Vadovas" field="director" placeholder="Vardas Pavardė"/>
                    </>
                  ) : (
                    <>
                      <F {...fp} label="Vardas Pavardė" field="fullName" placeholder="Vardas Pavardė"/>
                      <F {...fp} label="Asmens kodas" field="personalCode" placeholder="XXXXXXXXXXX"/>
                      <F {...fp} label="IV pažymėjimo Nr." field="ivNr" placeholder=""/>
                      <F {...fp} label="PVM mokėtojo kodas (jei yra)" field="pvmCode" placeholder="LT..."/>
                    </>
                  )}
                  <F {...fp} label="Adresas" field="address" placeholder="Gatvė, miestas, šalis"/>
                  <F {...fp} label="El. paštas" field="email" type="email" placeholder="info@pavyzdys.lt"/>
                  <F {...fp} label="Telefonas" field="phone" placeholder="+370 600 00000"/>
                  <F {...fp} label="Banko sąskaita (IBAN)" field="iban" placeholder="LT000000000000000000"/>
                  <F {...fp} label="Banko pavadinimas" field="bankName" placeholder="Swedbank, SEB..."/>
                  <F {...fp} label="Banko SWIFT/BIC" field="swift" placeholder="HABALT22"/>
                </div>

                <div className="mt-4 pt-4 border-t border-gray-100">
                  <label className={lbl}>Pastabos / papildoma informacija</label>
                  {editing
                    ? <textarea className={inp+" h-20 resize-none"} value={form.notes||''} onChange={e=>setForm(p=>({...p,notes:e.target.value}))} placeholder="Papildoma informacija pasiūlymams..."/>
                    : <div className="px-3 py-2 text-sm bg-gray-50 rounded-lg text-gray-600 min-h-10">{form.notes||<span className="text-gray-300">—</span>}</div>
                  }
                </div>
              </div>
            </div>
          );
        }
